export default __webpack_public_path__ + "static/media/04_AnimateByColumnsMovie_Right.c2fcd05f.mp4";